<template>
  <div class="dist-y">
    <prep-time-rules-form
      ref="merchantPrepTimeRulesForm"
      :value="merchantOrderRulesForm"
      @update="$event => handleOrderRulesUpdate({ type: 'merchant', orderRules: $event })"
    />

    <prep-time-rules-form
      v-for="(storeRules, storeId) in storeOrderRuleForms"
      :key="`store-rules-${storeId}`"
      :ref="`storePrepTimeRulesForm-${storeId}`"
      :value="storeRules"
      :store-id="storeId"
      @update="$event => handleOrderRulesUpdate({ type: 'store', storeId, orderRules: $event})"
    />

    <b-button
      icon-left="plus"
      type="is-primary is-light"
      outlined
      class="is-full-width is-full-height pad-lg"
      size="is-medium"
      @click="openAddPrepTimeRulesForStoreModal"
    >
      Store Prep Time Rules
    </b-button>
  </div>
</template>

<script>
  import merchantMixin from '@/mixins/merchant';

  import OrderRule from '@/store/classes/OrderRule';

  import AddStorePrepTimeRulesModal from './prep-time-rules/add-store-prep-time-rules-modal.vue';
  import PrepTimeRulesForm from './prep-time-rules/prep-time-rules-form.vue';


  export default {
    name: 'MerchantPrepTimeRulesTab',

    components: {
      PrepTimeRulesForm
    },

    mixins: [merchantMixin],

    data() {
      return {
        merchantOrderRulesForm: [],
        storeOrderRuleForms: {}
      };
    },

    computed: {
      merchantOrderRules() {
        return OrderRule
          .query()
          .where('merchantId', this.$_selectedMerchantId)
          .where('storeId', null)
          .orderBy('priority')
          .get();
      },

      storeOrderRuleGroups() {
        const groupedStoreRules = {};

        const storeOrderRules = OrderRule
          .query()
          .where('merchantId', this.$_selectedMerchantId)
          .where('storeId', storeId => storeId !== null)
          .orderBy('priority')
          .get();

        storeOrderRules
          .filter(rule => rule.merchantId === this.$_selectedMerchantId && rule.storeId)
          .forEach((rule) => {
            if (!groupedStoreRules[rule.storeId]) {
              groupedStoreRules[rule.storeId] = [];
            }
            groupedStoreRules[rule.storeId].push(rule);
          });

        return groupedStoreRules;
      }
    },

    async created() {
      this.onCreated();
    },

    methods: {
      async onCreated() {
        await this.fetchOrderRules();

        this.merchantOrderRulesForm = this.$clone(this.merchantOrderRules);
        this.storeOrderRuleForms = this.$clone(this.storeOrderRuleGroups);
      },

      async fetchOrderRules() {
        try {
          await OrderRule.fetchOrderRules();
        }
        catch (error) {
          this.$_onRequestError({
            toastOptions: { message: 'There was an error loading prep time rules' },
            error
          });
        }
      },

      handleOrderRulesUpdate({ type, storeId = null, orderRules }) {
        if (type === 'merchant') {
          this.merchantOrderRulesForm = orderRules;
        }
        else if (type === 'store' && storeId) {
          this.storeOrderRuleForms[storeId] = orderRules;
        }
      },

      openAddPrepTimeRulesForStoreModal() {
        const existingOrderRuleStoreIds = Object.keys(this.storeOrderRuleForms).map(storeId => Number(storeId));

        this.$buefy.modal.open({
          parent: this,
          component: AddStorePrepTimeRulesModal,
          hasModalCard: true,
          trapFocus: true,
          canCancel: false,
          customClass: 'auto-width',
          props: { existingOrderRuleStoreIds },
          events: {
            'add-order-rules-for-stores': storeIds => this.addOrderRulesForStore(storeIds)
          }
        });
      },

      addOrderRulesForStore(storeIds) {
        storeIds.forEach((storeId) => {
          const storeOrderRule = {
            isActive: true,
            merchantId: this.$_selectedMerchantId,
            storeId,
            minutesToAdd: null,
            priority: 1,
            ruleSegments: [
              { memberName: null, action: null, targetValue: null }
            ]
          };
          this.$set(this.storeOrderRuleForms, storeId, [storeOrderRule]);
        });
      }
    }
  };
</script>
